export const SMALLESTUNIT = 100000000;
export const totallimit = 10000000000000000;

export enum GridItemID {
  Market = "Market",
  TradeChart = "TradeChart",
  OrderBook = "OrderBook",
  MarketChanges = "MarketChanges",
  TradingKey = "TradingKey",
  UserBalances = "ConnectWallet",
  BuySellTab = "BuySellTab",
  OpenOrder = "OpenOrder",
  MarketTrades =  "MarketTrades"
}

export const GRID_LAYOUT = {
  lg: [
    {
      i: GridItemID.Market,
      x: 0,
      y: 0,
      h: 17,
      w: 7,
      minW: 4,
      minH: 5,
      resizeHandles: ["se"],
      isResizable: true,
      isDraggable: true
    },
    {
      i: GridItemID.TradeChart,
      x: 7,
      y: 0,
      h: 17,
      w: 11,
      minW: 6,
      minH: 6,
      resizeHandles: ["se"],
      isResizable: true,
      isDraggable: true
    },
    {
      i: GridItemID.OrderBook,
      x: 18,
      y: 0,
      h: 17,
      w: 6,
      minW: 3,
      minH: 2,
      resizeHandles: ["se"],
      isResizable: true,
      isDraggable: true
    },
    {
      i: GridItemID.MarketChanges,
      x: 24,
      y: 0,
      h: 6,
      w: 6,
      minW: 3,
      minH: 1,
      resizeHandles: ["se"],
      isResizable: false,
      isDraggable: true
    },
    {
      i: GridItemID.TradingKey,
      x: 24,
      y: 6,
      h: 2,
      w: 6,
      minW: 3,
      minH: 1,
      isResizable: false,
      resizeHandles: ["se"],
      isDraggable: true
    },
    {
      i: GridItemID.UserBalances,
      x: 24,
      y: 8,
      h: 6,
      w: 6,
      minW: 3,
      minH: 1,
      isResizable: false,
      resizeHandles: ["se"],
      isDraggable: true
    },
    {
      i: GridItemID.BuySellTab,
      x: 24,
      y: 14,
      h: 9,
      w: 6,
      minW: 3,
      minH: 1,
      isResizable: false,
      resizeHandles: ["se"],
      isDraggable: true
    },
    {
      i: GridItemID.OpenOrder,
      x: 0,
      y: 17,
      h: 10,
      w: 18,
      minW: 8,
      minH: 1,
      resizeHandles: ["se"],
      isResizable: true,
      isDraggable: true
    },
    {
      i: GridItemID.MarketTrades,
      x: 18,
      y: 17,
      h: 10,
      w: 6,
      minW: 3,
      minH: 1,
      resizeHandles: ["se"],
      isResizable: true,
      isDraggable: true
    }
  ],

  md: [
    {
      i: GridItemID.Market,
      x: 0,
      y: 0,
      h: 16,
      w: 8,
      minW: 4,
      minH: 4,
      resizeHandles: ["se"],
      isResizable: true,
      isDraggable: true
    },
    {
      i: GridItemID.TradeChart,
      x: 8,
      y: 0,
      h: 16,
      w: 8,
      minW: 6,
      minH: 6,
      resizeHandles: ["se"],
      isResizable: true,
      isDraggable: true
    },
    {
      i: GridItemID.OrderBook,
      x: 16,
      y: 0,
      h: 16,
      w: 7,
      minW: 3,
      minH: 2,
      resizeHandles: ["se"],
      isResizable: true,
      isDraggable: true
    },
    {
      i: GridItemID.MarketChanges,
      x: 23,
      y: 0,
      h: 6,
      w: 7,
      minW: 3,
      minH: 1,
      resizeHandles: ["se"],
      isResizable: false,
      isDraggable: true
    },
    {
      i: GridItemID.TradingKey,
      x: 23,
      y: 6,
      h: 2,
      w: 7,
      minW: 3,
      minH: 1,
      isResizable: false,
      resizeHandles: ["se"],
      isDraggable: true
    },
    {
      i: GridItemID.UserBalances,
      x: 23,
      y: 8,
      h: 6,
      w: 7,
      minW: 3,
      minH: 1,
      isResizable: false,
      resizeHandles: ["se"],
      isDraggable: true
    },
    {
      i: GridItemID.BuySellTab,
      x: 23,
      y: 14,
      h: 9,
      w: 7,
      minW: 3,
      minH: 1,
      isResizable: false,
      resizeHandles: ["se"],
      isDraggable: true
    },
    {
      i: GridItemID.OpenOrder,
      x: 0,
      y: 16,
      h: 9,
      w: 16,
      minW: 8,
      minH: 1,
      resizeHandles: ["se"],
      isResizable: true,
      isDraggable: true
    },
    {
      i: GridItemID.MarketTrades,
      x: 16,
      y: 16,
      h: 9,
      w: 7,
      minW: 3,
      minH: 1,
      resizeHandles: ["se"],
      isResizable: true,
      isDraggable: true
    }
  ],

  sm: [
    {
      i: GridItemID.Market,
      x: 0,
      y: 0,
      h: 20,
      w: 30,
      isResizable: false,
      isDraggable: false,
    }
  ],

  xs: [
    {
      i: GridItemID.Market,
      x: 0,
      y: 0,
      h: 20,
      w: 30,
      isResizable: false,
      isDraggable: false,
    }
  ],
};

const marketMFT = {
  i: GridItemID.Market,
  x: 0,
  y: 0,
  h: 19,
  w: 11.2,
  minW: 4,
  minH: 5,
  resizeHandles: ["se"],
  isResizable: true,
  isDraggable: true
};

const chartMFT = {
  i: GridItemID.TradeChart,
  x: 11.2,
  y: 0,
  h: 19,
  w: 6.8,
  minW: 6,
  minH: 6,
  resizeHandles: ["se"],
  isResizable: true,
  isDraggable: true
};

export const gridMFT = (gridLayout) => {
  const newLg = gridLayout.lg.map((doc) => 
    doc.i === "Market" 
      ? marketMFT 
      : doc.i === "TradeChart" 
        ? chartMFT 
        : doc
  );
  return { ...gridLayout, lg: newLg };
}

export const CUSTOMISE_VIEW_LIST = [
  {
    id: GridItemID.Market,
    title: "filter_options.market_label",
  },
  {
    id: GridItemID.TradeChart,
    title: "filter_options.tradechart_label",
  },
  {
    id: GridItemID.OrderBook,
    title: "filter_options.orderbook_label",
  },
  {
    id: GridItemID.OpenOrder,
    title: "filter_options.openorder_label",
  },
  {
    id: GridItemID.MarketTrades,
    title: "filter_options.markettrade_label",
  },
];

export const FONT_LAYOUT = {
  openOrder: 11,
  tableHead: 11,
  tableBody: 11,
  tickerHead: 13,
  tickerArrow: 15,
  tickerPrice: 12,
  minFont: 9,
};
